import { Lightning, Utils } from "@lightningjs/sdk";
import { PLAYER_DARK, PLAYER_PINK, playerText } from "./styles";
export class LinearSchedule extends Lightning.Component {
    static _template() {
        const panel = {
            h: 148,
            Background: {
                w: (w) => w,
                h: 148,
                rect: true,
                shader: {
                    type: Lightning.shaders.RoundedRectangle,
                    radius: 8,
                    fillColor: 0xcc161616,
                    stroke: 1,
                    strokeColor: 0xffffffff,
                },
            },
        };
        const time = {
            y: 16,
            text: Object.assign(Object.assign({}, playerText("", 24, 34)), { textAlign: "right" }),
        };
        const category = {
            x: 16,
            y: 110,
            text: {
                text: "Ligue 1+",
                fontFace: "Roboto",
                fontSize: 18,
                h: 24,
                offsetY: 20,
                textColor: 0xffffffff,
            },
        };
        return {
            w: 1690,
            h: 148,
            Current: Object.assign(Object.assign({}, panel), { w: 570, Tag: {
                    x: 16,
                    y: 16,
                    w: 71,
                    h: 34,
                    rect: true,
                    color: PLAYER_PINK,
                    shader: { type: Lightning.shaders.RoundedRectangle, radius: 8 },
                    Icon: {
                        x: 8,
                        y: 10,
                        w: 14,
                        h: 14,
                        texture: Lightning.Tools.getSvgTexture(Utils.asset("images/hero/live.svg"), 28, 28),
                    },
                    Label: {
                        x: 28,
                        text: Object.assign(Object.assign({}, playerText("LIVE", 24, 34)), { textColor: PLAYER_DARK }),
                    },
                }, Time: Object.assign(Object.assign({}, time), { x: 350, text: Object.assign(Object.assign({}, time.text), { w: 204 }) }), Title: {
                    x: 16,
                    y: 58,
                    text: Object.assign(Object.assign({}, playerText("", 36, 44)), { w: 538, textOverflow: "ellipsis" }),
                }, Category: category }),
            Next: Object.assign(Object.assign({}, panel), { x: 1300, w: 390, Tag: { x: 24, y: 16, text: playerText("UP NEXT", 24, 34) }, Time: Object.assign(Object.assign({}, time), { x: 170, text: Object.assign(Object.assign({}, time.text), { w: 204 }) }), Title: {
                    x: 16,
                    y: 58,
                    text: Object.assign(Object.assign({}, playerText("", 32, 40)), { w: 358, textOverflow: "ellipsis" }),
                }, Category: category }),
        };
    }
    set programme(programme) {
        var _a, _b, _c, _d;
        this.patch({
            Current: {
                Time: { text: { text: programme.time } },
                Title: { text: { text: programme.title } },
            },
            Next: {
                visible: !!programme.next,
                Time: { text: { text: (_b = (_a = programme.next) === null || _a === void 0 ? void 0 : _a.time) !== null && _b !== void 0 ? _b : "" } },
                Title: { text: { text: (_d = (_c = programme.next) === null || _c === void 0 ? void 0 : _c.title) !== null && _d !== void 0 ? _d : "" } },
            },
        });
    }
}
//# sourceMappingURL=LinearSchedule.js.map